import type {SyncIntegration} from '@cohort/merchants/apps';
import KlaviyoSyncConfigComponent from '@cohort/merchants/apps/klaviyo/sync/UserSyncConfigComponent';
import type {KlaviyoSyncStruct} from '@cohort/shared/apps/klaviyo/sync';
import {KlaviyoSyncSpec} from '@cohort/shared/apps/klaviyo/sync';

export const KlaviyoSyncIntegration: SyncIntegration<KlaviyoSyncStruct> = {
  spec: KlaviyoSyncSpec,
  syncConfigComponent: KlaviyoSyncConfigComponent,
};
